/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SingleReturnGetAlertCallDashboardStatsDto } from '../../models/single-return-get-alert-call-dashboard-stats-dto';

export interface ApiAlertcallsDashboardStatsGet$Params {}

export function apiAlertcallsDashboardStatsGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAlertcallsDashboardStatsGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<SingleReturnGetAlertCallDashboardStatsDto>> {
    const rb = new RequestBuilder(rootUrl, apiAlertcallsDashboardStatsGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<SingleReturnGetAlertCallDashboardStatsDto>;
        }),
    );
}

apiAlertcallsDashboardStatsGet.PATH = '/api/alertcalls/dashboard/stats';
